export class ApiEndpoints {
  public static readonly AUTH_LOGIN = "/auth/login";
  public static readonly USER_WORKSPACE = "/workspace/brands";
  public static readonly EXPORT_EXCEL = "/export/deductions";
  public static readonly EXPORT_CHARGE_BREAKDOWN = "/export/charge-breakdown";
  public static readonly UPLOAD_DEDUCTION_DOCUMENT = "/upload/deduction-document";
  public static readonly UPLOAD_CREDIT_DOCUMENT = "/upload/credit-document";
  public static readonly UPLOAD_DEDUCTION_BACKUP = "/upload/deduction-backup";
  public static readonly DEDUCTION_ACTIVITIES_EXPORT = "/export/deduction-activities";
  public static readonly INTELLI_UPLOAD_NEW_DOCUMENT = "/intelli-upload/upload-documents";
  public static readonly PURGE_DATA = "/workspace/purge-transactions";
  public static readonly UPLOAD_CONVERSATION_ATTACHMENT = "/upload/conversation-attachment";
  public static readonly UPLOAD_PROMOTION_DOCUMENT = "/upload/promotion-document";
  public static readonly EXPORT_REMITTANCE_DOCUMENTS = "/export/remittance-documents";
  public static readonly EXPORT_PROMO_PRODUCTS = "/export/promo-products";
}
